import BaseEntity from '../BaseEntity.model';
import Height from './Height.model';
import { StatusEnum } from '../../Enum/StatusEnum';

export default interface IMembersVitalSigns extends BaseEntity {
    MemberId: string;
    Height: Height;
    Weight: string;
    BmiValuation: string;
    BMI: string | null;
    BpPulse: string;
    BpSystolic: string;
    BpDiastolic: string;
    PulseOxSpO2Last: string;
    IsRoomAir: boolean;
    O2FlowRate: string;
    GlucoseMgDl: string;
    RespirationRate: string;
    RefusedForAssessment: boolean;
    SpokeWithFamily: string;
    SpokeWithFriends: string;
    HealthEvaluation: string;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    Temperature: string;
    RecordingDate: Date;
    IsBPAi: boolean;
    IsHealthEvaluationAi: boolean;
    IsGlucoseAi: boolean;
    IsBPPulseAi: boolean;
    IsHeightAi: boolean;
    IsRefusedForAssessmentAi: boolean;
    IsPulseOxSpO2LastAi: boolean;
    IsRespirationRateAi: boolean;
    IsBmiValuationAi: boolean;
    IsSpokeWithFamilyAi: boolean;
    IsSpokeWithFriendsAi: boolean;
    IsWeightAi: boolean;
    IsTemperatureAi: boolean;
}

export class MembersVitalSigns implements IMembersVitalSigns {
    Id: string;
    MemberId: string;
    Height: Height;
    Weight: string;
    BmiValuation: string;
    BMI: string | null;
    BpPulse: string;
    BpSystolic: string;
    BpDiastolic: string;
    PulseOxSpO2Last: string;
    IsRoomAir: boolean;
    O2FlowRate: string;
    GlucoseMgDl: string;
    RespirationRate: string;
    RefusedForAssessment: boolean;
    SpokeWithFamily: string;
    SpokeWithFriends: string;
    HealthEvaluation: string;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    VitalSignResultStatus: StatusEnum;
    Temperature: string;
    RecordingDate: Date;
    IsBPAi: boolean;
    IsHealthEvaluationAi: boolean;
    IsGlucoseAi: boolean;
    IsBPPulseAi: boolean;
    IsHeightAi: boolean;
    IsRefusedForAssessmentAi: boolean;
    IsPulseOxSpO2LastAi: boolean;
    IsRespirationRateAi: boolean;
    IsBmiValuationAi: boolean;
    IsSpokeWithFamilyAi: boolean;
    IsSpokeWithFriendsAi: boolean;
    IsWeightAi: boolean;
    IsTemperatureAi: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.BpSystolic = '';
        this.BpDiastolic = '';
        this.BpPulse = '';
        this.GlucoseMgDl = '';
        this.RespirationRate = '';
        this.Weight = '';
        this.PulseOxSpO2Last = '';
        this.IsRoomAir = false;
        this.O2FlowRate = '';
        this.Height = null;
        this.BMI = null;
        this.SpokeWithFamily = '';
        this.SpokeWithFriends = '';
        this.HealthEvaluation = '';
        this.IsAssessmentCompleted = false;
        this.RefusedForAssessment = false;
        this.BmiValuation = '';
        this.AssessmentStatus = 0;
        this.Temperature = '';
        this.IsBPAi = false;
        this.IsHealthEvaluationAi = false;
        this.IsGlucoseAi = false;
        this.IsBPPulseAi = false;
        this.IsHeightAi = false;
        this.IsRefusedForAssessmentAi = false;
        this.IsPulseOxSpO2LastAi = false;
        this.IsRespirationRateAi = false;
        this.IsBmiValuationAi = false;
        this.IsSpokeWithFamilyAi = false;
        this.IsSpokeWithFriendsAi = false;
        this.IsWeightAi = false;
        this.IsTemperatureAi = false;
    }
}
